/**
 * 指定位置までスクロールする関数
 */
function $scrollAnimation(selector){
	var $target = $(selector);
	if($target.length !== 0){
		var position = $target.offset().top - 20; //ターゲット位置を取得
		var $header = $('.g-header'); //ヘッダー取得
		if($header.length !== 0 && $header.css('display') !== 'none'){ //ヘッダー分位置をずらす
			position = position - $header.outerHeight();
			var $sp_menu_btn = $header.find('.g-header__sp-toggle__menu'); //スマホメニューボタン取得
			if($sp_menu_btn.hasClass('_active')){ //スマホメニュー開いているか
				$sp_menu_btn.trigger("click"); //スマホメニュー閉じる
			} 
		}
		$("html,body").animate({scrollTop:position},500); //ターゲット位置までscroll
	}
}

/**
 * ページ内リンククリック時にスクロールアニメーションさせる。
 */
$(document).on('click','a[href^="#"]',function(){
	var selector = $(this).attr('href');
	$scrollAnimation(selector);
	return false;
});